import './App.css';
import { Fragment } from 'react';
import MiniMap from './main/components/minimap';
import EventLog from './main/components/event_log';
import ActionPanel from './main/components/actionPanel';
import { useState, useEffect } from "react";
import ControlArrows from './main/components/controlArrow';
import ViewPort from './main/components/view_port';
import { preloadTextures } from './main/utils/textures';
import LoadingScreen from './main/components/LoadingScreen';
import PartyStatus from './main/components/partyStatus';
import PartyPortraits from './main/components/partyPortraits';
import CombatStatus from './main/components/combatStatus';
import FullscreenPrompt from './main/components/fullscreenPrompt';
import CharacterSheet from './main/components/characterSheet';
import LaunchMenu from './main/components/launchMenu';
import RunSummary from './main/components/runSummary';
import TrainingHall from './main/components/trainingHall';
import MagicSchool from './main/components/magicSchool';
import Market from './main/components/market';
import Temple from './main/components/temple';
import Tavern from './main/components/tavern';
import MapScreen from './main/components/mapScreen';
import MapEditor from './main/components/mapEditor';
import GemButton from './main/components/gemButton';
import GameMenu from './main/components/gameMenu';
import { withContext } from './main/utils/StateProvider';

// Below this scale the 1920x1080 layout's text is too small to read, so
// switch to the compact styles (larger text, shorter log)
const COMPACT_SCALE = 0.5;

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      //Force mainFrame to maximum scaling for window size maintaining an aspect ratio for 1920 x 1080px
      // visualViewport excludes mobile browser toolbars, which come and go
      const viewport = window.visualViewport;
      let windowHeight = viewport ? viewport.height : window.innerHeight;
      let windowWidth = viewport ? viewport.width : window.innerWidth;
      let scale = windowHeight / 1080;
      scale = ( (1920 * scale ) > windowWidth ) ? windowWidth/1920 : scale;
      
      //Uncomment to Force No Scale if greater than 1
      scale = (scale > 1) ? 1 : scale;
      
      let mainFrame = document.getElementById('mainFrame');
      mainFrame.style.scale=scale;
      mainFrame.classList.toggle('compact', scale < COMPACT_SCALE);
      mainFrame.style.marginLeft = '0px';
      mainFrame.style.marginTop = '0px';
      let bounds = document.getElementById('mainFrame').getBoundingClientRect()
      mainFrame.style.marginLeft = ( (windowWidth-bounds.width) / 2) - bounds.x + 'px';

      if(bounds.height < windowHeight){
          mainFrame.style.marginTop = ((windowHeight - bounds.height) / 2) - bounds.y +  'px';
      } else {
          mainFrame.style.marginTop = (0 - bounds.top ) +  'px';
      }
      console.log('Scale', scale)
      console.log('Window Height', windowHeight)
      console.log('Window Width', windowWidth)
      console.log('Top', document.getElementById('mainFrame').offsetTop)
      console.log('Bounds', bounds)
      //appendToEventLog('ViewPort Changed ' + '['+windowWidth +','+windowHeight+']', 'dev');
    }

    // Rotating, entering/leaving fullscreen and toolbar changes all resize the screen
    const targets = [
      [window, 'resize'],
      [window, 'orientationchange'],
      [document, 'fullscreenchange'],
      [document, 'webkitfullscreenchange'],
      ...(window.visualViewport ? [[window.visualViewport, 'resize']] : [])
    ];
    targets.forEach(([target, event]) => target.addEventListener(event, handleResize));
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listeners on cleanup
    return () => targets.forEach(([target, event]) => target.removeEventListener(event, handleResize));
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

// The launch menu and the end-of-run summary sit over everything else
const Screens = withContext(({ context }) => {
  if (context.screen === 'menu') return <LaunchMenu />;
  if (context.screen === 'editor') return <MapEditor />;
  if (context.screen === 'complete') return <RunSummary />;
  return null;
});

function App() {
  const [texturesLoaded, setTexturesLoaded] = useState(false);

  useEffect(() => {
    // Load the painted textures before drawing the dungeon
    preloadTextures().then(() => {
      setTexturesLoaded(true);
    });
  }, []);

  useWindowSize();
  if (!texturesLoaded) {
    return <LoadingScreen />;
  }

  return (
    <Fragment>
      <ViewPort />
      
      {/*<div id="viewPort">
          VIEWPORT

          <EventLog />
      </div>*/}

      <EventLog />
      <MiniMap />
      <PartyStatus />
      <ActionPanel />

      <ControlArrows />
      
      <PartyPortraits />
      <CombatStatus />
      <CharacterSheet />
      <TrainingHall />
      <MagicSchool />
      <Market />
      <Temple />
      <Tavern />
      <MapScreen />
      <GemButton />
      <GameMenu />
      <Screens />
      <FullscreenPrompt />
    </Fragment>
  );
}

export default App;